import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2, ArrowRight } from 'lucide-react';

const packages = [
  { name: 'PLATINIUM', space: '+15m²', maxSpace: '36m²', price: 'Sur devis', accent: '#94A3B8', featured: false, features: ['Stand d\'exposition (jusqu\'à 36m²)', 'Logo sur signalétique & écran', 'Keynote speaker panel haut niveau', '5 interventions speaker', 'Insertion quadri magazine URBANIK', '+5 cartes dîner gala'] },
  { name: 'DIAMOND', space: '15m²', price: '2 500 000 FCFA', accent: '#89CFF0', featured: false, features: ['Stand d\'exposition 15m²', 'Logo sur signalétique & écran', 'Keynote speaker panel haut niveau', '3 interventions speaker', 'Insertion quadri magazine URBANIK', '5 cartes dîner gala'] },
  { name: 'GOLDEN', space: '12m²', price: '2 000 000 FCFA', accent: '#DAA520', featured: true, features: ['Stand d\'exposition 12m²', 'Logo sur signalétique & écran', 'Keynote speaker panel haut niveau', '1 intervention speaker', 'Insertion quadri magazine URBANIK', '3 cartes dîner gala', 'Animation d\'atelier pratique'] },
  { name: 'SILVER', space: '09m²', price: '1 500 000 FCFA', accent: '#A8A8A8', featured: false, features: ['Stand d\'exposition 09m²', 'Logo sur signalétique & écran', 'Keynote speaker panel haut niveau', 'Insertion quadri magazine URBANIK', '2 cartes dîner gala', 'Animation d\'atelier pratique'] },
  { name: 'BRONZE', space: '06m²', price: '1 000 000 FCFA', accent: '#CD7F32', featured: false, features: ['Stand d\'exposition 06m²', 'Logo sur signalétique & écran', 'Keynote speaker panel haut niveau', 'Insertion quadri magazine URBANIK', '1 carte dîner gala', 'Animation d\'atelier pratique'] },
  { name: 'PROXY', space: '03m²', price: '500 000 FCFA', accent: '#1E3A5F', featured: false, features: ['Stand d\'exposition 03m²', 'Logo sur signalétique & écran', 'Insertion quadri magazine URBANIK', 'Réduction 50% cartes dîner gala', 'Animation d\'atelier pratique'] },
];

const Exposant = ({ onOpenForumModal }) => (
  <div className="min-h-screen pt-16">
    {/* PAGE HERO */}
    <section className="relative py-24 lg:py-32 bg-[#1E3A5F] overflow-hidden" data-testid="exposant-hero">
      <div className="absolute inset-0 opacity-10" aria-hidden="true" />
      <div className="relative container-institutional">
        <p className="text-sm font-semibold uppercase tracking-widest text-[#F5A623] mb-4">Participation</p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-5 leading-tight">Devenez Exposant</h1>
        <p className="text-lg text-white/70 max-w-2xl leading-relaxed">Choisissez le niveau de partenariat adapté à votre ambition et présentez vos innovations aux décideurs.</p>
      </div>
    </section>

    {/* OFFERS */}
    <section className="py-20 lg:py-28" data-testid="offres-section">
      <div className="container-institutional">
        <div className="text-center mb-16">
          <p className="text-sm font-semibold uppercase tracking-widest text-[#F5A623] mb-3">Offres</p>
          <h2 className="text-3xl font-bold text-[#1E3A5F] mb-4">Nos Offres de Participation</h2>
          <p className="text-[#6B7C93] max-w-2xl mx-auto">6 niveaux de partenariat pour répondre à toutes les ambitions.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {packages.map((pkg) => (
            <div key={pkg.name} className={`bg-white border rounded-lg overflow-hidden transition-shadow ${pkg.featured ? 'border-[#F5A623] shadow-lg ring-1 ring-[#F5A623]/20' : 'border-[#E1E8F0] hover:shadow-md'}`} data-testid={`package-${pkg.name.toLowerCase()}`}>
              {pkg.featured && <div className="bg-[#F5A623] text-[#1E3A5F] text-center py-1.5 text-xs font-bold uppercase tracking-wider">Populaire</div>}
              <div className="p-6 text-center" style={{ borderBottom: `3px solid ${pkg.accent}` }}>
                <h3 className="text-lg font-bold text-[#1E3A5F]">{pkg.name}</h3>
                <p className="text-xs text-[#94A3B8] mt-1">Stand {pkg.space}{pkg.maxSpace ? ` (jusqu'à ${pkg.maxSpace})` : ''}</p>
                <p className="text-2xl font-bold text-[#1E3A5F] mt-3">{pkg.price}</p>
              </div>
              <div className="p-6">
                <ul className="space-y-3">
                  {pkg.features.map((f) => (
                    <li key={f} className="flex items-start gap-2.5 text-sm text-[#4A5568]"><CheckCircle2 className="w-4 h-4 text-[#F5A623] flex-shrink-0 mt-0.5" /><span>{f}</span></li>
                  ))}
                </ul>
                <button onClick={onOpenForumModal} className="mt-6 w-full btn-secondary text-sm py-3" data-testid={`package-btn-${pkg.name.toLowerCase()}`}>Souscrire <ArrowRight className="w-4 h-4 ml-1" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-20 lg:py-28 bg-[#1E3A5F]" data-testid="exposant-cta">
      <div className="container-institutional text-center">
        <h2 className="text-3xl font-bold text-white mb-4">Besoin d'aide pour choisir ?</h2>
        <p className="text-white/70 max-w-xl mx-auto mb-8">Contactez notre service commercial pour un accompagnement personnalisé.</p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/exposition/stands" className="btn-primary text-base px-8 py-4">Voir le plan des stands <ArrowRight className="w-5 h-5 ml-2" /></Link>
          <Link to="/participer" className="btn-outline border-white text-white hover:bg-white hover:text-[#1E3A5F] text-base px-8 py-4">Nous contacter</Link>
        </div>
      </div>
    </section>
  </div>
);

export default Exposant;
